<template>
  <div>
    <div class="row" style="align-items: center; margin-bottom: 0.5rem">
      <div class="col-8">
        <h3 style="margin: 0">{{ nome }}</h3>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button
          class="md-icon-button md-raised md-dense"
          style="margin-right: 4px"
          @click="abrirGoogleMaps"
        >
          <md-icon>map</md-icon>
          <md-tooltip md-direction="left">Maps</md-tooltip>
        </md-button>
        <md-button
          class="md-icon-button md-list-action"
          @click="$emit('close')"
        >
          <md-icon>close</md-icon>
          <md-tooltip md-direction="left">Fechar</md-tooltip>
        </md-button>
      </div>
    </div>

    <md-tabs md-alignment="fixed" md-dynamic-height>
      <md-tab md-label="Gráficos">
        <div class="row" style="align-items: center; margin-bottom: 1rem">
          <div class="col-12">
            <md-field style="border-bottom: none; margin: 0">
              <label for="filtro-rapido-mapa">Período</label>
              <md-select
                id="filtro-rapido-mapa"
                v-model="filtro.offset"
                name="filtro-rapido-mapa"
                @md-selected="fetchSensores"
              >
                <md-option :value="ms(30, 'min')">30 min</md-option>
                <md-option :value="ms(1, 'hora')">1 hora</md-option>
                <md-option :value="ms(2, 'hora')">2 horas</md-option>
                <md-option :value="ms(4, 'hora')">4 horas</md-option>
                <md-option :value="ms(8, 'hora')">8 horas</md-option>
                <md-option :value="ms(24, 'hora')">24 horas</md-option>
              </md-select>
            </md-field>
          </div>
        </div>

        <div v-if="loading" style="text-align: center; padding: 2rem">
          <md-progress-spinner
            :md-diameter="60"
            :md-stroke="5"
            md-mode="indeterminate"
          />
        </div>

        <div v-else-if="sensores !== null && sensores.length === 0">
          <md-empty-state
            md-rounded
            md-icon="timeline"
            md-label="Sem dados"
            md-description="Não há dados de sensores para esse equipamento no período selecionado."
          />
        </div>

        <div v-else-if="sensores !== null">
          <div
            v-for="[tipo, data] in sensores"
            :key="tipo"
            class="col-12 p-0"
            style="margin-bottom: 1rem"
          >
            <graphic-area
              :sensores="data"
              :tipo="tipo"
              :range="filtro.range"
              :max-value="filtro.maxValue"
              height="250"
            />
          </div>
        </div>
      </md-tab>

      <md-tab v-if="canSendAction()" md-label="Ações">
        <EquipamentoAcoes ref="acoes" @changeAcao="$emit('change-acao')" />
      </md-tab>
    </md-tabs>
  </div>
</template>

<script>
import GraphicArea from '@/components/GraphicArea.vue'
import auth from '@/utils/auth'
import http from '@/utils/http'

import EquipamentoAcoes from './EquipamentoAcoes'

export default {
  name: 'EquipamentoMapaDrawer',
  components: { EquipamentoAcoes, GraphicArea },
  props: {
    equipamentoId: {
      type: [String, Number],
      required: true,
    },
    nome: {
      type: String,
      default: '',
    },
    latitude: {
      type: [String, Number],
      required: true,
    },
    longitude: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      sensores: null,
      tiposSensores: {},
      filtro: {
        offset: 1000 * 60 * 60 * 2,
        range: 1000 * 60 * 60 * 2,
        maxValue: new Date().getTime(),
      },
    }
  },
  watch: {
    equipamentoId: {
      immediate: true,
      handler() {
        this.sensores = null
        this.fetchSensores()

        this.$nextTick(() => {
          if (this.$refs.acoes) {
            this.$refs.acoes.searchAcoes(this.equipamentoId)
          }
        })
      },
    },
  },
  async created() {
    const response = await http.get('tiposSensores', {}, false)
    if (response && response.tiposSensores) {
      this.tiposSensores = response.tiposSensores.reduce((acc, e) => {
        acc[e.tipo] = e
        return acc
      }, {})
    }
  },
  methods: {
    canSendAction: auth.canSendAction,
    abrirGoogleMaps() {
      const url = `https://www.google.com/maps?q=${this.latitude},${this.longitude}`
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    ms(n, unit) {
      switch (unit) {
        case 'min':
          return 1000 * 60 * n
        case 'hora':
          return 1000 * 60 * 60 * n
        default:
          return 0
      }
    },
    async fetchSensores() {
      if (!this.equipamentoId) return

      this.loading = true

      const periodoISO = new Date(
        new Date().getTime() - this.filtro.offset
      ).toISOString()

      this.filtro.range = this.filtro.offset
      this.filtro.maxValue = new Date().getTime()

      const response = await http.get(
        `equipamento/${this.equipamentoId}/sensores`,
        { periodo: periodoISO },
        false
      )

      if (!response) {
        this.loading = false
        return
      }

      let tipos = Object.keys(response.sensores)

      tipos = tipos.sort(
        (a, b) =>
          (this.tiposSensores[a]?.prioridade ?? 0) -
          (this.tiposSensores[b]?.prioridade ?? 0)
      )

      this.sensores = tipos.map((tipo) => [tipo, response.sensores[tipo]])

      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
